import React from 'react';
import './../css/NavBar.css'
import { connect } from 'react-redux';

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import App from '../App';
import Footer from './Footer';
import Home from './Home';
import { bindActionCreators } from 'redux';
import { updateFilter } from './../actions/action-filter'

class NavBar extends React.Component{

    handleClick = (type) => {
        console.log(type);
        this.props.updateFilter(type);
    }

    render() {
        return (
            <div className="navbar">
                <button onClick={() => this.handleClick("")}>All</button>
                <button onClick={() => this.handleClick("seafood")}>Seafood</button>
                <button onClick={() => this.handleClick("meat")}>Meats</button>
                <button onClick={() => this.handleClick("grain")}>Grains</button>
                <button onClick={() => this.handleClick("bean")}>Beans</button>
                <button onClick={() => this.handleClick("vegetable")}>Vegetables</button>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({updateFilter}, dispatch)
}

export default connect(null, mapDispatchToProps)(NavBar);